import React, { useContext } from "react";
import { Center, Spinner } from "@reverb-ui/react";
import { ClientEmployeeContext } from "@/shared/presentation/context-api/providers/client-employee";
import { CompanyList } from "../../components/company-list";
import { CompanyOwner } from "../../components/company-owner";
export var CompanyContainer = function () {
    var _a = useContext(ClientEmployeeContext), employee = _a.employee, loading = _a.loading, isOwnerOrAdminOfAnyClient = _a.isOwnerOrAdminOfAnyClient;
    if (loading) {
        return (React.createElement(Center, { w: "full", p: 12 },
            loading,
            React.createElement(Spinner, { color: "blue.500" })));
    }
    if (!employee) {
        return React.createElement(React.Fragment, null, "No Employee Data");
    }
    if (!isOwnerOrAdminOfAnyClient())
        return React.createElement(CompanyList, { clients: employee.clients });
    if (isOwnerOrAdminOfAnyClient())
        return React.createElement(CompanyOwner, null);
    return React.createElement(React.Fragment, null, "Company");
};
